import type { Category } from './valueObjects/category';
import type { CategoryId } from './valueObjects/categoryId';
import type { CategoryIndex } from './valueObjects/categoryIndex';
import type { PrivateBlogCategoryJson } from '@/types/domain/privateBlog/entities/privateBlogCategoryEntity';

import { Entity } from '@/domain/entity';
import { DeleteType } from '@/domain/entityRepositoryBase';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * カテゴリプロパティ
 */
export type PrivateBlogCategoryProps = {
  /** カテゴリID */
  categoryId: CategoryId,
  /** カテゴリインデックス */
  categoryIndex: CategoryIndex,
  /** カテゴリ */
  category: Category,
}

/**
 * カテゴリEntity
 */
export class PrivateBlogCategoryEntity extends Entity<
  PrivateBlogCategoryProps,
  PrivateBlogCategoryJson
> {
  /**
   * 削除タイプ
   */
  get deleteType(): DeleteType {
    return DeleteType.PrivateBlogCategoryId;
  }

  /**
   * 削除キー
   */
  get deleteKey(): string {
    return this.categoryId.value;
  }

  /**
   * データJsonを返す
   * @returns データ
   */
  toJsonData(): PrivateBlogCategoryJson {
    return {
      categoryId: this.categoryId.value,
      categoryIndex: this.categoryIndex.value,
      category: this.category.value,
      itemCount: 0,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityName {
    return EntityName.WagakoNurseryPrivateBlogCategoryEntity;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return `${this.categoryId.value}`;
  }

  /**
   * サブキー
   */
  get subKey() {
    return `${this.categoryId.value}#${this.category.value}`;
  }

  /**
   * カテゴリID
   */
  get categoryId(): CategoryId {
    return this._value.categoryId;
  }

  /**
   * カテゴリID
   */
  set categoryId(categoryId: CategoryId) {
    this._value.categoryId = categoryId;
  }

  /**
   * カテゴリインデックス
   */
  get categoryIndex(): CategoryIndex {
    return this._value.categoryIndex;
  }

  /**
   * カテゴリインデックス
   */
  set categoryIndex(categoryIndex: CategoryIndex) {
    this._value.categoryIndex = categoryIndex;
  }

  /**
   * カテゴリ
   */
  get category(): Category {
    return this._value.category;
  }

  /**
   * カテゴリ
   */
  set category(category: Category) {
    this._value.category = category;
  }
}
